module.exports = __webpack_public_path__ + "img/antes_despues_194.3eb0c817.png";